<script setup lang="ts">
interface Props {
   variant?: 'centered' | 'left';
   titleSize?: string;
   titleColor?: string;
}

const props = withDefaults(defineProps<Props>(), {
   variant: 'centered',
   titleSize: 'text-2xl',
   titleColor: 'text-brand-primary'
});

const containerClass = computed(() => {
   return props.variant === 'centered' ? 'flex-col items-center' : 'flex-col';
});
</script>

<template>
   <div class="flex" :class="containerClass">
      <span
         class="font-semibold uppercase"
         :class="[titleSize, titleColor]">
         International Polo
      </span>
   </div>
</template>
